import React from 'react';
import { CONTAINED_VARIANT, NO_ICON, SIZE_44, BTN_DARK_THEME, Button } from '@yme/atoms/button';
import { Image as ImageAtom } from '@yme/atoms/image';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { ButtonLinkWrapper } from '@yme/molecules/buttons';
import { colorCoreWhite1000, colorWhiteTransparent800 } from '@yme/tokens/colors';
import { CardsListCardSizes } from './constants';
import { CardsListCardStyled, ImageBgStyled, ImageMaskStyled, Title, FlexWrapperStyled, Subtitle, } from './styled';
export function CardsListCard(props) {
    const { image, title, subtitle, learnMoreLabel, size = CardsListCardSizes.SMALL, link, isRightToLeft, } = props;
    const { isMobileView } = useWindowSize();
    return (React.createElement(ButtonLinkWrapper, { buttonLink: link },
        React.createElement(CardsListCardStyled, { isLargeCard: size === CardsListCardSizes.LARGE },
            React.createElement(ImageBgStyled, null,
                React.createElement(ImageAtom, { ...image }),
                React.createElement(ImageMaskStyled, null)),
            React.createElement(FlexWrapperStyled, { isRightToLeft: isRightToLeft, flexDirection: "column", alignItems: "flex-start", isSizeLarge: size === CardsListCardSizes.LARGE },
                subtitle && React.createElement(Subtitle, { color: colorWhiteTransparent800 }, subtitle),
                React.createElement(Title, { color: colorCoreWhite1000 }, title),
                React.createElement(Button, { width: isMobileView ? '100%' : 'auto', buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, size: SIZE_44, label: learnMoreLabel, isRightToLeft: isRightToLeft, colorSchema: BTN_DARK_THEME })))));
}
